import React, { HTMLAttributes } from 'react';
import cn from 'classnames';
import SVG from '@components/Icons/SVGWrapper';
import styles from './NavBarToggle.module.scss';

const ScreenGraphic = () => (
  <>
    <rect strokeWidth="1.5" x="0.75" y="1.5" width="13.5" height="12" rx="3" fill="none" />
    <path strokeWidth="1.5" d="M5.25 1.5v12" />
  </>
);

const Arrow = ({ direction }: { direction: 'left' | 'right' }) => {
  const transform = direction === 'right' ? 'rotate(180, 9.6, 7.5)' : '';
  return (
    <path
      d="M8.6 7.5 10.2 5.9v3.2L8.6 7.5Z"
      strokeWidth="1.43"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform={transform}
    />
  );
};

const PinNavBarIcon = () => (
  <SVG viewBox="0 0 15 15" width="15" height="15" color="primary">
    <ScreenGraphic />
    <Arrow direction="right" />
  </SVG>
);

const HideNavBarIcon = () => (
  <SVG viewBox="0 0 15 15" width="15" height="15" color="primary">
    <ScreenGraphic />
    <Arrow direction="left" />
  </SVG>
);

const _PinNavBarButton = ({ className, ...props }: HTMLAttributes<HTMLButtonElement>, ref) => (
  <button ref={ref} className={cn('btn-none', styles.btn, className)} {...props}>
    <PinNavBarIcon />
  </button>
);

export const PinNavBarButton = React.forwardRef<HTMLElement, any>(_PinNavBarButton);

export const HideNavBarButton = ({ className, ...props }: HTMLAttributes<HTMLButtonElement>) => (
  <button className={cn('btn-none', styles.btn, className)} {...props}>
    <HideNavBarIcon />
  </button>
);
